import React from 'react';
import Router from 'next/router';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import {ButtonGroup, Divider, Navbar, Button, Card, Elevation} from '@blueprintjs/core';
import {createGlobalStyle} from 'styled-components';

import styled from 'styled-components';

const Container = styled.div`
        margin: auto;
        max-width: 90%;
        padding-top: 5vw;
        padding-bottom: 5vw;
`;

const GlobalStyle = createGlobalStyle`
        body {
                background-image: url("https://wallet.swissx.com/FAT-2.svg");
                background-size:  64px;
                background-repeat: no-repeat;
        }
`;

const AnimatedNumber = ({id, value}) => {
	const [ number, setNumber ] = React.useState(null);

	let currNum
	let ticks;
	let fresh = true;
	const time = 1000;
	const ref = React.useRef(null);

	React.useEffect(() => {
		if(!number)
			setup(value);
		else 
			update(value);
		setNumber(value);
	}, [value]);

	function scrollNumber(digits) {
		var stat = ref ? ref.current : null;
		if(!stat)
			return;
  	    	stat.querySelectorAll('span[data-value]').forEach((tick, i) => {
			var mul = parseInt(digits[i]);
			if(isNaN(mul))
				mul = 10;
        		tick.style.transform = `translateY(-${100 * mul}%)`;
    		})

    		setTimeout(() => {
        		stat.style.width = `${digits.length * 20}px`;
    		}, 100)
	}

	function addDigit(digit, fresh) {
		var stat = ref ? ref.current : null;
		if(!stat)
			return;
	    const spanList = Array(10)
	        .join(0)
	        .split(0)
	        .map((x, j) => `<span>${j}</span>`)
	        .join('')+'<span>.</span><span>&nbsp;</span>';

	    stat.insertAdjacentHTML(
	        "beforeend",
	        `<span style="transform: translateY(-1000%)" data-value="${digit}">
	        ${spanList}
	      </span>`)

	    const firstDigit = stat.lastElementChild

	    setTimeout(() => {
	        firstDigit.className = "visible";
	    }, fresh ? 0 : 2000);
	}

	function removeDigit() {
		var stat = ref ? ref.current : null;
	    const firstDigit = stat.lastElementChild
	    firstDigit.classList.remove("visible");
	    setTimeout(() => {
        	firstDigit.remove();
	    }, 2000);
	}

	function setup(startNum) {
	    const digits = startNum.toString().split('')

	    for (let i = 0; i < digits.length; i++) {
        	addDigit('0', true)
	    }

	    scrollNumber(['0'])

	    setTimeout(() => scrollNumber(digits), 2000)
	    currNum = startNum
	}

	function rollToNumber(idx, num) {
		if(num == '.')
			num = 10;
	    el.style.transform = `translateY(-${100 - num * 10}%)`;
	}

	function update(num) {
	    const toDigits = num.toString().split('')
	    const fromDigits = currNum.toString().split('')

	    for (let i = fromDigits.length - toDigits.length; i > 0; i--) {
	        removeDigit()
	    }
	    for (let i = toDigits.length - fromDigits.length; i > 0; i--) {
	        addDigit(toDigits[i]);
	    }

	    scrollNumber(toDigits)
	    currNum = num
	}

	return (
		<span key={id} className="number" id={id} ref={ref}></span>
	);
};

const symbolsList = [
	{
		symbol: 'NYMEX:NGO',
		title: 'CBL NATURE-BASED GLOBAL EMISSIONS OFFSET FUTURES',
		chart: () => (<iframe id="tradingview_b8b69" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b8b69&symbol=NYMEX%3ANGO1!&interval=D&hidetoptoolbar=1&saveimage=0&toolbarbg=f1f3f6&studies=%5B%5D&theme=light&style=10&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=carboncredits.com&utm_medium=widget&utm_campaign=chart&utm_term=NYMEX%3ANGO1!" style={{width: "100%", height: "100%", margin: "0 !important", padding: "0 !important"}} frameBorder="0" allowtransparency="true" scrolling="no" allowFullScreen=""> </iframe>),
	},
	{
		symbol: 'NYMEX:CGO',
		title: 'CBL CORE GLOBAL EMISSIONS OFFSET (C-GEO) FUTURES',
		chart: () => (<iframe id="tradingview_46812" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_46812&symbol=NYMEX%3ACGO1!&interval=D&hidetoptoolbar=1&saveimage=0&toolbarbg=f1f3f6&studies=%5B%5D&theme=light&style=10&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=carboncredits.com&utm_medium=widget&utm_campaign=chart&utm_term=NYMEX%3ACGO1!" style={{width: "100%", height: "100%", margin: "0 !important", padding: "0 !important"}} frameBorder="0" allowtransparency="true" scrolling="no" allowFullScreen=""></iframe>),
	},
	{
		symbol: 'ICEEUR:ECF',
		title: 'EUA FUTURES',
		currency: 'EUR',
		chart: () => (<iframe id="tradingview_00770" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_00770&symbol=ICEEUR%3AECF1!&interval=D&hidetoptoolbar=1&saveimage=0&toolbarbg=f1f3f6&studies=%5B%5D&theme=light&style=10&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=carboncredits.com&utm_medium=widget&utm_campaign=chart&utm_term=ICEEUR%3AECF1!" style={{width: "100%", height: "100%", margin: "0 !important", padding: "0 !important"}} frameBorder="0" allowtransparency="true" scrolling="no" allowFullScreen=""></iframe>),
	},
	{
		symbol: 'NYMEX:CC3',
		title: 'CBL CALIFORNIA CARBON ALLOWANCE VINTAGE-SPECIFIC 2023 FUTURES',
		chart: () => (<iframe id="tradingview_e8297" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_e8297&symbol=NYMEX%3ACC31!&interval=D&hidetoptoolbar=1&saveimage=0&toolbarbg=f1f3f6&studies=%5B%5D&theme=light&style=10&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=carboncredits.com&utm_medium=widget&utm_campaign=chart&utm_term=NYMEX%3ACC31!" style={{width: "100%", height: "100%", margin: "0 !important", padding: "0 !important"}} frameBorder="0" allowtransparency="true" scrolling="no" allowFullScreen=""></iframe>),
	},
	{
		symbol: 'NYMEX:GEO',
		title: 'CBL GLOBAL EMISSIONS OFFSET FUTURES',
		chart: () => (<iframe id="tradingview_c6ce0" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_c6ce0&symbol=NYMEX%3AGEO1!&interval=D&hidetoptoolbar=1&saveimage=0&toolbarbg=f1f3f6&studies=%5B%5D&theme=light&style=10&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=carboncredits.com&utm_medium=widget&utm_campaign=chart&utm_term=NYMEX%3AGEO1!" style={{width: "100%", height: "100%", margin: "0 !important", padding: "0 !important"}} frameBorder="0" allowtransparency="true" scrolling="no" allowFullScreen=""></iframe>),
	},
	{
		symbol: 'NYMEX:LCF',
		title: 'CALIFORNIA LOW CARBON FUEL STANDARD (PRIMA) FUTURES',
		chart: () => (<iframe id="tradingview_c6ce0" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_c6ce0&symbol=NYMEX%3ALCF1!&interval=D&hidetoptoolbar=1&saveimage=0&toolbarbg=f1f3f6&studies=%5B%5D&theme=light&style=10&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=carboncredits.com&utm_medium=widget&utm_campaign=chart&utm_term=NYMEX%3ALCF1!" style={{width: "100%", height: "100%", margin: "0 !important", padding: "0 !important"}} frameBorder="0" allowtransparency="true" scrolling="no" allowFullScreen=""></iframe>),
	},
];


export const Stocks = (params) => {
	const [ futures, setFutures ] = React.useState([]);
	const [ symbol, setSymbol] = React.useState(symbolsList[0].symbol);
	const [ symbolTitle, setSymbolTitle] = React.useState(symbolsList[0].title);
	const [ symbols, setSymbols ] = React.useState(symbolsList);
	var kind = 'buy';
	
	React.useEffect(() => {
		kind = (Router && Router.query && Router.query.sell) ? 'sell' : 'buy';
	}, [Router]);
	React.useEffect(() => {
		loadRates(symbol);
		const idx = symbols.findIndex(e => e.symbol == symbol);
		setSymbolTitle(symbols[idx].title);
	}, [symbol]);

	React.useEffect(() => {
//		console.debug("got futures", futures);
	}, [futures]);
	
	const loadRate = (symbol) => {
		const data = '{ "columns": [ "close", "change", "Perf.W", "Perf.1M", "Perf.6M", "Perf.YTD", "Perf.Y", "Perf.5Y", "Perf.All" ], "range": [ 0, 1 ], "symbols": { "tickers": [ "'+symbol+'1!" ] } }';
		fetch('https://scanner.tradingview.com/futures/scan', {method: 'POST', body: data})
                .then(response => response.json())
                .then(data => {
//                        console.debug("LR", data.data[0]);
			const s = symbols;
			const sidx = s.findIndex(e => e.symbol == symbol);
//			console.debug("INDEX", sidx);
			s[sidx].rate = data.data[0].d[0];
			s[sidx].change = data.data[0].d[1];
			setSymbols(s);
		})
		.catch(e => console.error(e));
	}
	const loadRates = (symbol) => {
		const data = '{ "columns": [ "pricescale", "minmov", "expiration", "close", "change", "name" ], "filter": [ { "left": "close", "operation": "nempty" }, { "left": "root", "operation": "equal", "right": "'+symbol+'" } ], "ignore_unknown_fields": false, "sort": { "sortBy": "expiration", "sortOrder": "asc" }, "markets": [ "futures" ] }';
		fetch('https://scanner.tradingview.com/futures/scan', {method: 'POST', body: data})
		.then(response => response.json())
		.then(data => {
//			console.debug(data);
			setFutures(data.data || []);
		})
		.catch(e => console.error(e));
	}
							//<span class="rate">{symbols[idx].rate ? symbols[idx].rate.toFixed(2) : '0.00'}</span>

	return (
		<Container>
                        <Card elevation={Elevation.FOUR} style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around'}}>
				<span style={{width: '100%', paddingBottom: '30px'}}><a href="https://wallet.swissx.com">&lt; Back</a></span>
				{symbols.map(e => {
					loadRate(e.symbol);
					const idx = symbols.findIndex(el => el.symbol == e.symbol);
					return (<>
						<Button key={`button${e.symbol}`} id={e.symbol} icon={"pulse"} onClick={() => setSymbol(e.symbol) } className="ratebtn">
						<h4>{e.symbol}</h4>
						<div style={{display: "flex", flexDirection: "column"}}>
							<AnimatedNumber id={`number${e.symbol}`} value={symbols[idx].rate ? symbols[idx].rate.toFixed(2) : 0} />
							<div style={{display: 'flex', flexDirection: 'row'}}>
								<span className="currency">{symbols[idx].currency || 'USD'}</span>
								<span className={symbols[idx].change < 0 ? "changedown" : "changeup"}>{symbols[idx].change > 0 && '+'}{symbols[idx].change ? symbols[idx].change.toFixed(2) : '0.00'}%</span>
							</div>
						</div>
						</Button>
					</>);
				})}
			</Card>
			<Divider />
			<Card>
				<h4 align='center'>{symbolTitle}</h4>
				<Card elevation={Elevation.TWO}>
					{symbols.find(i => i.symbol == symbol).chart()}
				</Card>
				{futures.sort(e => e.d[2] ? 1 : -1).map(e => {
					const datestr = e.d[2] ? e.d[2]+'' : null;
					const date = datestr ? new Date() : null;
					if(datestr) {
						const y = datestr.substring(0,4);
						const m = datestr.substring(4,6);
						date.setFullYear(y);
						date.setMonth(m);
					} 
					const sel = symbols.find(i => i.symbol == symbol);
					const currency = sel && sel.currency ? sel.currency : 'USD';
					return (
						<Card interactive={true} style={{cursor: 'default'}} key={`card${e.d[5]}`} onClick={() => {
//							kind = Router.query && Router.query.sell ? 'sell' : 'buy';
//							Router.push('/'+kind+'?product='+symbol+':'+e.d[5]+':'+(e.d[2]||'')+'&rate='+e.d[3]);	
							//Router.push('/'+kind+'?product='+symbol+':'+e.d[5]+':'+(e.d[2]||'')+'&rate='+e.d[3]);	
						}}>
							<h5>{e.d[5]} {date ? date.toLocaleDateString(undefined, {month: "long", year: "numeric"}) : "continuous"}</h5>
							<div style={{display: "flex", flexDirection: "row", flexWrap: 'wrap'}}>
								<span className="rate">{e.d[3] ? e.d[3].toFixed(2) : '0.00'}</span>
								<div style={{display: 'flex', flexDirection: 'column'}}>
									<span className="currency">{currency}</span>
									<span className={e.d[4] < 0 ? "changedown" : "changeup"}>{e.d[4] > 0 &&'+'}{e.d[4] ? e.d[4].toFixed(2) : '0.00'}%</span>
								</div>
								<div style={{display: 'flex', flexDirection: 'row', paddingLeft: '20px', paddingTop: '20px'}}>
									<span style={{cursor: 'pointer'}} onClick={() => {
										kind = 'buy';
										Router.push('/'+kind+'?product='+symbol+':'+e.d[5]+':'+(e.d[2]||'')+'&rate='+e.d[3]);	
									}}>
										<img src="https://wallet.swissx.com//img/buybtn.png" style={{height: '60px', border: 0}} />
									</span>
									<span style={{cursor: 'pointer'}} onClick={() => {
										kind = 'sell';
										Router.push('/'+kind+'?product='+symbol+':'+e.d[5]+':'+(e.d[2]||'')+'&rate='+e.d[3]);	
									}}>
										<img src="https://wallet.swissx.com//img/sellbtn.png" style={{height: '60px', border: 0}} />
									</span>
								</div>
							</div>
						</Card>
					);
				})}
			</Card>
		</Container>
	);
}	
export default Stocks;

